'use client';
import { Box, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import slide1 from "../../assets/images/Vertica/vertica-slide-1.jpeg"
import slide2 from "../../assets/images/Vertica/vertica-slide-2.jpeg"
import product1 from "../../assets/images/Vertica/vertica-product-1.jpeg"
import product2 from "../../assets/images/Vertica/vertica-product-2.jpeg"
import product3 from "../../assets/images/Vertica/vertica-product-3.jpeg"
import product4 from "../../assets/images/Vertica/vertica-product-4.jpeg"
import alfaMallWhite from "../../assets/images/Vertica/alfamall-white.svg"
import "./index.scss"
const Vertica = () => {
    let settings = {
        autoplay: true,
        autoplayspeed: 1000,
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        waitForAnimate: false,
        fade: true,
        arrows: false,
    };
    return (
        <>
            <Box sx={{
                backgroundColor: 'white',
            }}>
                <Box sx={{
                    backgroundColor: "#D62314",
                    width: "99.3vw",
                    padding: '10px',
                    zIndex: 2,
                    position: 'relative'
                }}>
                    <Box display="flex" justifyContent="center">
                        <img src={alfaMallWhite.src} width="188px" height="64px" alt='alfa-mall' />
                    </Box>
                </Box>
                <Box className="vertica-slider">
                    <Box
                        mt="50px"
                        paddingTop="15px"
                        paddingBottom="50px"
                    >
                        <Slider {...settings}>
                            <Box
                                sx={{
                                    display: "flex !important"
                                }}
                                justifyContent="center">
                                <img src={slide2.src} width="80%" style={{
                                    border: '2px solid #d62215'
                                }} />
                            </Box>
                            <Box
                                sx={{
                                    display: "flex !important"
                                }}
                                justifyContent="center">
                                <img src={slide1.src} width="80%" style={{
                                    border: '2px solid #d62215'
                                }} />
                            </Box>
                            <Box
                                sx={{
                                    display: "flex !important"
                                }}
                                justifyContent="center">
                                <img src={slide2.src} width="80%" style={{
                                    border: '2px solid #d62215'
                                }} />
                            </Box>
                        </Slider>
                    </Box>
                    <Box py="15px">
                        <Typography sx={{
                            color: 'black',
                            fontSize: '50px',
                            textAlign: 'center'
                        }}>
                            Digital Lifestyle Favourites
                        </Typography>
                    </Box>
                    <Grid container px={6} className="vertica-product-tiles-container" justifyContent="space-between">
                        <Grid item xs={3.8} sx={{
                            boxShadow: '3px 3px 8px',
                            borderRadius: "15px"
                        }}>
                            <Stack spacing={1}>
                                <img style={{ borderRadius: "15px 15px 15px 15px" }} src={product1.src} width="auto" height="auto" alt='product' />
                                <Box>
                                    <Typography sx={{
                                        textAlign: "center"
                                    }}>
                                        Rs. 42,999
                                    </Typography>
                                </Box>
                            </Stack>
                        </Grid>
                        <Grid item xs={3.8} sx={{
                            boxShadow: '3px 3px 8px',
                            borderRadius: "15px"
                        }}>
                            <Stack spacing={1}>
                                <img style={{ borderRadius: "15px 15px 15px 15px" }} src={product2.src} width="auto" height="auto" alt='product' />
                                <Box>
                                    <Typography sx={{
                                        textAlign: "center"
                                    }}>
                                        Rs. 42,999
                                    </Typography>
                                </Box>
                            </Stack>
                        </Grid>
                        <Grid item xs={3.8} sx={{
                            boxShadow: '3px 3px 8px',
                            borderRadius: "15px"
                        }}>
                            <Stack spacing={1}>
                                <img style={{ borderRadius: "15px 15px 15px 15px" }} src={product3.src} width="auto" height="auto" alt='product' />
                                <Box>
                                    <Typography sx={{
                                        textAlign: "center"
                                    }}>
                                        Rs. 42,999
                                    </Typography>
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    )
}

export default Vertica;